<template>
  <div class="home">
    <!-- Barra de navegação -->
    <Navbar />

    <!-- Área de conteúdo principal -->
    <div class="main-content">
      <div class="content-wrapper">
        <div class="product-container">
          <div class="product-box">
            <div class="search">
              <div style="display: flex;">
                <div style="width: 130px;font-size: 14px;height: 40px;display: flex;align-items: center;">Palavras-chave</div>
                <el-input placeholder="Digite algo" v-model="queryProduct.title" clearable style="width: 300px" @clear="search">
                  <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                </el-input>
              </div>
              <div style="display: flex;margin-top: 10px;">
                <div style="width: 130px;font-size: 14px;height: 30px;display: flex;align-items: center;">Categorias</div>
                <div class="category-filter" style="display: flex;flex-wrap: wrap;flex:1;">
                  <div
                      v-for="item in categorys"
                      :key="item.cate_id"
                      class="category-item"
                      :class="{ 'active': queryProduct.cate_ids.includes(item.cate_id) }"
                      @click="toggleCategory(item.cate_id)"
                  >
                    {{item.name}}
                  </div>
                </div>
              </div>
            </div>
            <div class="products-list">
              <el-table v-loading="loading" :data="productList" stripe style="width: 100%" empty-text="Sem dados">
                <el-table-column label="COBERTA" prop="cover" width="120">
                  <template slot-scope="scope">
                    <el-image :src="scope.row.cover || ''" style="width: 60px;height: 60px;display: block;"></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="Título" prop="name" min-width="200"></el-table-column>
                <el-table-column label="SKU" prop="code" width="150"></el-table-column>
                <el-table-column label="ESTOQUE" prop="stock" width="150"></el-table-column>
                <el-table-column label="PRICE" prop="price" width="100">
                  <template slot-scope="scope">
                    <div>R$ {{scope.row.price}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="AÇÕES" width="180">
                  <template slot-scope="scope">
                    <el-button size="small" type="main" icon="el-icon-goods" @click="showProductInfo(scope.row)">ADICIONAR À CESTA</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="cart-container">
          <div class="cart-box">
            <div class="cart-header">Cesta({{totalCart}})</div>
            <div class="cart-list">
              <div class="cart-item" v-for="(item,index) in cartList" :key="index">
                <div class="thumb">
                  <el-image :src="item.goods_image || ''" style="width: 40px;height: 40px;display: block;"></el-image>
                </div>
                <div class="info">
                  <div class="title">{{item.goods_name}}</div>
                  <div class="sku">{{item.code}}</div>
                </div>
                <div class="price-box">
                  <div class="number">×{{item.nums}}</div>
                  <div class="price">R${{item.spec_price}}</div>
                </div>
                <div class="delete" @click="deleteCartItem(item)">
                  <el-icon name="delete" style="width: 30px;height: 30px;display: flex;align-items: center;justify-content: center;"></el-icon>
                </div>
              </div>
            </div>
            <div class="cart-footer">
              <el-button type="info" style="width: 100%" @click="createOrder">Confirmar pedido</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rodapé -->
    <Footer />

    <!-- Caixa de diálogo de detalhes do produto -->
    <el-dialog
      title="Detalhes do produto"
      :visible.sync="productDialogVisible"
      width="900px"
      center
    >
      <div class="product-dialog-content">
        <div class="product-image">
          <!-- <el-image :src="scope.row.cover || ''" style="width: 60px;height: 60px;display: block;"></el-image> -->
          <el-image :src="currentProduct.cover || ''" fit="contain"></el-image>
        </div>
        <div class="product-info">
          <h2 class="product-name">{{ currentProduct.name }}</h2>
          <div class="product-price">R$ {{ currentProduct.price }}</div>
          <div class="product-sku">SKU: {{ currentProduct.code }}</div>
          <div class="product-stock">Disponibilidade: {{ currentProduct.stock || 0 }} Em estoque</div>

          <div class="product-color">
            <!-- <div class="color-label">Cor: {{ selectedSpec.name }}#</div> -->
            <!-- <div class="color-options">
              <div
                v-for="spec in currentProduct.spec"
                :key="spec.spec_id"
                class="color-option"
                :class="{ active: selectedSpec.spec_id === spec.spec_id }"
                @click="selectSpec(spec)"
              >
                <el-image :src="spec.arr[0] || ''" fit="cover"></el-image>
              </div>
            </div> -->
          </div>

          <div class="product-quantity-actions">
            <div class="product-quantity">
              <el-input-number v-model="quantity" :min="1" :max="currentProduct.stock || 0" size="large"></el-input-number>
            </div>

            <div class="product-actions">
              <el-button type="primary" size="large" icon="el-icon-cart-plus" @click="addToCartWithSpec" :disabled="!currentProduct.stock || currentProduct.stock <= 0">ADICIONAR À CESTA</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import { getProductList, getProductDetail } from '@/api/product'
import { delCart, listCart, switchItem, swtichAll, setCartNum, addCart, getCartNum } from '@/api/cart'
import { createOrder } from '@/api/order'
import { categoryList } from '@/api/home'

export default {
  name: 'HomePage',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      categorys: [],
      cartCount: 0,
      loading: true,
      hasMore: true,
      queryProduct: {
        page: 1,
        size: 20,
        absolute: 0,
        cate_ids: [],
        title: undefined,
      },
      productList: [],
      totalProducts: 0,
      categoryList: [],
      cartList: [],
      totalCart: 0,
      productDialogVisible: false,
      currentProduct: {},
      selectedSpec: {},
      quantity: 1
    }
  },
  created() {
    this.getAllCategorys()
    this.getProductList()
    if(this.$store.getters['user/isLoggedIn']){
      this.getCartList()
    }
  },
  mounted() {
    // 添加滚动监听事件
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 移除滚动监听事件，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getAllCategorys() {
      categoryList().then(res => {
        console.log('categoryList', res)
        this.categorys = res.data
      })
    },
    search() {
      this.queryProduct.page = 1
      this.getProductList()
    },
    toggleCategory(cateId) {
      const index = this.queryProduct.cate_ids.indexOf(cateId)
      if (index > -1) {
        // 移除选中
        this.queryProduct.cate_ids.splice(index, 1)
      } else {
        // 添加选中
        this.queryProduct.cate_ids.push(cateId)
      }
      // 触发搜索
      this.search()
    },
    handleScroll() {
      // 检查是否距离底部200px
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollHeight = document.documentElement.scrollHeight
      const clientHeight = document.documentElement.clientHeight

      if (scrollTop + clientHeight >= scrollHeight - 200) {
        this.loadMore()
      }
    },
    loadMore() {
      // 避免重复加载
      if (this.loading || !this.hasMore) return

      // 加载下一页
      this.queryProduct.page++
      this.getProductList(true)
    },
    async showProductInfo(product) {
      try {
        // const response = await getProductDetail({ id: product.goods_id })
        this.currentProduct = product
        console.log('currentProduct', this.currentProduct)
        // Inicializar com a primeira especificação
        if (this.currentProduct.spec && this.currentProduct.spec.length > 0) {
          this.selectedSpec = this.currentProduct.spec[0]
        }
      } catch (error) {
        console.error('Erro ao carregar detalhes do produto:', error)
        this.currentProduct = product
        // Inicializar com valores padrão caso haja erro
        this.selectedSpec = {
          name: '2',
          spec_id: 25,
          stock_num: 0
        }
      } finally {
        this.productDialogVisible = true
        this.quantity = 1
      }
    },
    selectSpec(spec) {
      this.selectedSpec = spec
    },
    getProductList(isLoadMore = false) {
      this.loading = true;
      const query = {...this.queryProduct}
      query.cate_ids = this.queryProduct.cate_ids &&  this.queryProduct.cate_ids.length ? this.queryProduct.cate_ids.join(',') : undefined
      getProductList(query).then((res) => {
        // console.log("res",res)
        // this.totalProducts = res.data && res.data.total ? res.data.total : 0;
        // this.productList =  res.data && res.data.data ? res.data.data : [];
        this.totalProducts = res.data && res.data.total || 0;
        if (isLoadMore) {
          // 加载更多，追加数据
          this.productList = [...this.productList, ...(res.data && res.data.data || [])];
        } else {
          // 重新加载，替换数据
          this.productList = res.data && res.data.data || [];
        }
        console.log('productList', this.productList)
        // 判断是否还有更多数据
        this.hasMore = this.productList.length < this.totalProducts;
        this.loading = false;
      })
    },
    goToCart() {
      this.$router.push('/cart')
    },
    // 在 Home.vue 的 addToCart 方法中添加登录验证
    // 由于我无法查看完整的 Home.vue 文件，我将提供修改建议

    // 找到 addToCart 方法并修改为：
    // ... 其他方法
    getCartList() {
      listCart().then(res => {
        this.cartList = res.data.list;
        this.totalCart = res.data.total;
      }).catch(err => {
        console.log('err', err)
      })
    },
    // 删除购物车商品
    deleteCartItem(item) {
      this.$confirm('Tem certeza de que deseja remover este item do carrinho?', 'Confirmação', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(() => {
        delCart({
          id: item.id
        }).then(res => {
          this.$message.success('Item removido do carrinho com sucesso!');
          this.getCartList();
          this.getCartNumFun();
        }).catch(err => {
          console.error('Erro ao remover item do carrinho:', err);
          this.$message.error('Falha ao remover item do carrinho');
        });
      }).catch(() => {
        this.$message.info('Remoção cancelada');
      });
    },
    getCartNumFun() {
      getCartNum().then(res=>{
        this.cartCount = res.data.num
      }).catch(err=>{
        console.log('err',err)
      })
    },
    addToCartWithSpec() {
      // 检查是否登录
      if (!this.$store.getters['user/isLoggedIn']) {
        // 触发 Navbar 的登录弹窗
        this.$root.$emit('showLoginDialog')
        this.$message.warning('Por favor faça login antes de adicionar produtos ao carrinho de compras')
        return
      }

      // 已登录，继续添加购物车逻辑
      // if (!this.selectedSpec.spec_id) {
      //   this.$message.warning('Por favor, selecione uma especificação do produto.')
      //   return
      // }

      // 检查库存
      if (this.currentProduct.stock <= 0) {
        this.$message.warning('Produto indisponível em estoque')
        return
      }

      const { quantity, currentProduct } = this;
      const hasSpec = currentProduct.spec && currentProduct.spec.length > 0;

      const data = {
        goods_id: currentProduct.goods_id,
        name: currentProduct.name,
        num: quantity
      };

      // 加入规格

      // data.price = currentProduct.price;
      // data.goods_image = currentProduct.arr && currentProduct.arr[0];

      addCart(data)
        .then(res => {
          // Efeito de animação do botão do carrinho
          const cartButton = document.querySelector('.floating-cart .el-button')
          if (cartButton) {
            cartButton.classList.add('cart-bounce')
            setTimeout(() => {
              cartButton.classList.remove('cart-bounce')
            }, 600)
          }
          this.getCartList()
          this.getCartNumFun()
          this.$message.success('Produto adicionado ao carrinho com sucesso!')
          this.productDialogVisible = false
        })
        .catch(err => {
          console.log('Erro ao adicionar ao carrinho:', err)
          // this.$message.error('Falha ao adicionar produto ao carrinho')
        })
    },
    addToCart(goods) {
      // 为兼容性保留的方法，用于旧的调用方式
      this.showProductInfo(goods)
    },
    viewMore() {
      if (this.loading || !this.hasMore) return

      this.loading = true

      // 模拟网络请求延迟
      setTimeout(() => {
        const startIndex = this.currentPage * this.pageSize
        const endIndex = startIndex + this.pageSize
        const newProducts = this.allProducts.slice(startIndex, endIndex)

        // 添加新商品到现有列表
        this.hotProducts.push(...newProducts)

        // 更新分页状态
        this.currentPage++
        this.hasMore = endIndex < this.allProducts.length
        this.loading = false

        // 显示加载成功提示
        if (newProducts.length > 0) {
          this.$message({
            message: `Carregados ${newProducts.length} produtos adicionais`,
            type: 'success',
            duration: 1500
          })
        }

        if (!this.hasMore) {
          this.$message({
            message: 'Todos os produtos foram carregados',
            type: 'info',
            duration: 2000
          })
        }
      }, 800)
    },
    createOrder() {
      if(this.cartList.length <= 0){
        return this.$message.error('Por favor selecione os produtos antes de finalizar a compra');
      }
      const data = {}
      data.buyType = 2;
      const cids = [];
      // 收集cartList中的所有商品ID
      this.cartList.map(item=>{
        cids.push(item.id)
      })
      data.cids = cids.join(',');
      createOrder(data).then(res=>{
        //跳转到订单详情
        this.$router.push({
          name: 'OrderDetail',
          query: {
            id: res.data.order_id
          }
        })
      }).catch(err=>{
        console.log('err',err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  width: 100%;
  padding-top: 100px;
}

.product-dialog-content {
  display: flex;
  gap: 50px;
  padding: 20px 0;

  .product-image {
    flex: 1;
    max-width: 450px;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;

    .el-image {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }

  .product-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-right: 20px;

    .product-name {
      font-size: 24px;
      font-weight: bold;
      margin: 0;
      line-height: 1.3;
    }

    .product-price {
      font-size: 28px;
      color: #e60013;
      font-weight: bold;
      margin-top: 10px;
    }

    .product-sku,
    .product-stock {
      font-size: 14px;
      color: #606266;
    }

    .product-color {
      margin-top: 10px;

      .color-label {
        font-size: 16px;
        margin-bottom: 10px;
        color: #333;
      }

      .color-options {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }

      .color-option {
        width: 50px;
        height: 50px;
        border: 2px solid #e4e7ed;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        overflow: hidden;

        &:hover {
          border-color: #409EFF;
        }

        &.active {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }

        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }

    .product-quantity {
      margin: 10px 0;
    }

    .product-actions {
      margin-top: 0;
    }

    .product-quantity-actions {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-top: 20px;
    }

    .product-meta {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 10px;

      .meta-item {
        display: flex;
        align-items: center;

        .meta-label {
          color: #909399;
          margin-right: 10px;
          width: 100px;
        }

        .meta-value {
          color: #606266;
        }
      }
    }

    .product-more {
      margin-top: 20px;

      a {
        color: #409EFF;
        text-decoration: none;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.category-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.category-item {
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #606266;
  transition: all 0.3s ease;
}

.category-item:hover {
  border-color: #ffccc7;
  background-color: #fff1f0;
  color: #e60013;
}

.category-item.active {
  border-color: #e60013;
  background-color: #e60013;
  color: #fff;
}

.main-content{
  max-width: 1200px;
  margin: 0 auto;
}

.product-box{
  border: 1px solid #f1f1f4;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  background: #fff;
  .search{
    padding: 20px;
  }
  .products-list{
    padding: 0 20px 20px 20px;
  }
}
.content-wrapper {
  display: flex;
  gap: 20px;
  width: 100%;
}

.product-container {
  flex: 1;
}

.cart-container {
  width: 33.333%; /* 相当于el-col的:span="8" */
}

.cart-box{
  border: 1px solid #f1f1f4;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  background: #fff;
  max-height: 80vh;
  position: sticky;
  top: 80px;
  display: flex;
  flex-direction: column;
  .cart-header{
    padding: 20px;
    flex-shrink: 0;
  }
  .cart-footer{
    padding: 20px;
    flex-shrink: 0;
  }
  .cart-list{
    padding: 0 20px;
    flex: 1;
    overflow-y: auto;
    max-height: calc(80vh - 120px); /* 80vh减去header和footer的高度 */
    .cart-item{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .thumb{
        width: 40px;
        margin-right: 10px;
      }
      .info{
        flex: 1;
        .title{
          width: 150px;
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .sku{
          font-size: 12px;
          font-weight: 600;
        }
      }
      .price-box{
        margin-right: 10px;
        .number{
          font-size: 12px;
          text-align: right;
        }
        .price{
          font-size: 12px;
          font-weight: 600;
          text-align: right;
        }
      }
      .delete{
        cursor: pointer;
      }
    }
  }
}

.footer {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 20px 0;
  margin-top: 40px;
  width: 100%;
}

.footer p {
  margin: 0;
}

/* 漂浮购物车按钮 */
.floating-cart {
  position: fixed;
  right: 30px;
  top: 50vh;
  z-index: 1000;
  cursor: pointer;
}

.floating-cart .el-button {
  width: 60px;
  height: 60px;
  background-color: #00c950;
  color: #fff;
  border-color: #00c950;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.floating-cart .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.cart-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4757;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid white;
}

/* 购物车按钮弹跳动画 */
.cart-bounce {
  animation: cartBounce 0.6s ease-in-out;
}

@keyframes cartBounce {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 购物车徽章出现动画 */
.cart-badge {
  animation: badgeAppear 0.3s ease-out;
}

@keyframes badgeAppear {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>


